import { useEffect, useRef } from "react";
import { useAppSelector } from "../store";
import { usePrevious } from "./usePrevious";

export function useOnBulkImportFinishedCallback(callback: () => void) {
  const parkingProductsBulkImportProgress = useAppSelector(
    (s) => s.parkingProducts.bulkImportProgress.progress
  );
  const entryRightsBulkImportProgress = useAppSelector((s) => s.entryRights.bulkImportProgress.progress);
  const previousParkingProductsBulkImportProgress = usePrevious(parkingProductsBulkImportProgress);
  const previousEntryRightsBulkImportProgress = usePrevious(entryRightsBulkImportProgress);

  // want fresh callback, but don't want to rerun the effect if it changes...
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const parkingProductsImportFinished =
      parkingProductsBulkImportProgress === 100 && previousParkingProductsBulkImportProgress !== 100;
    const entryRightsImportFinished =
      entryRightsBulkImportProgress === 100 && previousEntryRightsBulkImportProgress !== 100;

    if (parkingProductsImportFinished || entryRightsImportFinished) {
      callbackRef.current();
    }
  }, [
    parkingProductsBulkImportProgress,
    previousParkingProductsBulkImportProgress,
    entryRightsBulkImportProgress,
    previousEntryRightsBulkImportProgress,
  ]);
}
